import React, { useEffect, useState } from "react";
import {
  Badge,
  Nav,
  NavItem,
  NavLink as RsNavLink,
  NavbarBrand,
  Label,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import cross from "../../../public/svg/x-symbol-svgrepo-com.svg";
import MediaQuery from "react-responsive";
import NavbarToggler from "reactstrap/lib/NavbarToggler";
import { Prompt } from "react-router-dom";
import { EnvironmentSign } from "bx-react-ui";
import { Icons } from "../UI/Icon/Icon";
import { ConfirmDataOnboarding } from "../Onboarding/ConfirmDataOnboarding/ConfirmDataOnboarding";
import style from "./SidebarOnboarding.scss";
import { getSavedPersonInfo } from "../../reducers/selectors";
import { getPersonInfo } from "../../services/api/person";
import { personInfoSet } from "../../actions/entities";
import { ContractOnboarding } from "../Onboarding/ContractOnboarding/ContractOnboarding";

const environmentName = window.___APP_CONFIG___.ENV_NAME
  ? window.___APP_CONFIG___.ENV_NAME
  : "TESTING";

const SidebarOnboarding = ({ isProdEnv }) => {
  const dispatch = useDispatch();
  const [indexSidebar, setIndexSidebar] = useState(0);
  const [mobileSidebar, setMobileSidebar] = useState(false);
  const showEnvironmentSign = !isProdEnv || isTestingUser;
  const environmentSignText = isProdEnv ? "PRODUCTION" : environmentName;
  const environmentSignColor = isProdEnv ? "red" : "#34784B";

  const elementsSidebarOnboarding = [
    // "Confirmá tus datos",
    "Contrato único",
    // "Cuentas",
    "Perfil del inversión",
    "Declaración PEP",
  ];

  useEffect(() => {
    getPersonInfo()
      .then(({ response }) => {
        dispatch(personInfoSet(response.personInfo));
      })
      .catch((err) => console.error(err))
  }, []);

  const updateSidebar = () => {
    setIndexSidebar(indexSidebar + 1);
  };

  const toggleMobileSidebar = () => {
    setMobileSidebar((stateMobile) => !stateMobile);
  };

  const mobileSidebarToggle = (e) => {
    toggleMobileSidebar();
  };

  const MenuItems = () => {
    return (
      <div className={style.menuItems}>
        {elementsSidebarOnboarding.map((menuElement, index) => (
          <div key={index} className={style.textMenu}>
            {index < indexSidebar ? (
              <li className={style.checked}>
                <Icons.RadioCheckedIcon size="md" />
                {menuElement.toString()}
              </li>
            ) : (
              <div>
                {index === indexSidebar ? (
                  <li key={index} className={style.active}>
                    <div className={style.greenCircle}>
                      <Icons.CheckedMenu size="md" />
                    </div>
                    {menuElement.toString()}
                  </li>
                ) : (
                  <li key={index} className={style.unchecked}>
                    <Icons.UncheckedMenu size="md" />
                    {menuElement.toString()}
                  </li>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={style.containerSidebar}>
      <div
        className={
          mobileSidebar ? style.sidebarMobile : style.sidebarOnboarding
        }
      >
        <MediaQuery minWidth={1024}>
          <div className={style.header}>
            <Icons.HomeIconWhite className={style.homeIcon} />
            <div className={style.verticalLine}></div>
            <Label className={style.logoLabel}>Casa de Bolsa</Label>
          </div>
          <div>
            <hr className={style.hr} />
          </div>

          <div className={style.optionsContainer}>
            <div className={style.optionsTitle}> Configuración de perfil </div>
            <div>
              <ul className={style.sidebarMenu}>
                <MenuItems />
              </ul>
            </div>
          </div>
        </MediaQuery>
        {mobileSidebar && (
          <MediaQuery maxWidth={1023}>
            <span id={style.mobileSidebarHeader}>
              <img
                src={cross}
                alt="cross"
                className={style.cross}
                onClick={(e) => {
                  mobileSidebarToggle(e);
                }}
              />
            </span>

            <div className={style.header}>
              <Icons.HomeIcon className={style.homeIcon} />
              <div className={style.verticalLine}></div>
              <Label className={style.logoLabel}>Casa de Bolsa</Label>
            </div>
            <div>
              <hr className={style.hr} />
            </div>

            <div className={style.optionsContainer}>
              <div className={style.optionsTitle}>
                {" "}
                Configuración de perfil{" "}
              </div>
              <div>
                <ul className={style.sidebarMenu}>
                  <MenuItems />
                </ul>
              </div>
            </div>
          </MediaQuery>
        )}
        <MediaQuery minWidth={576}>
          {showEnvironmentSign && (
            <EnvironmentSign
              text={environmentSignText}
              color={environmentSignColor}
            />
          )}
        </MediaQuery>
      </div>
      {/* {
        <ConfirmDataOnboarding
          activeSidebar={mobileSidebar}
          toggleMobileSidebar={toggleMobileSidebar}
          confirmPersonInfo={updateSidebar}
          confirmContract={updateSidebar}
          confirmAccounts={updateSidebar}
          confirmInvestmentProfile={updateSidebar}
        />
      } */}
      {
        <ContractOnboarding 
          toggleMobileSidebar={toggleMobileSidebar}
          confirmContract={updateSidebar}
          confirmAccounts={updateSidebar}
          confirmInvestmentProfile={updateSidebar}
        />
      }
    </div>
  );
};

export default SidebarOnboarding;
